import { useTranslation } from 'react-i18next';
import type { UnsavedGuard } from '@/shared/useUnsavedGuard';
import { ConfirmDialog } from './ConfirmDialog';

/**
 * The question a held navigation asks (TMMAPP-0073, TMM-B5): rendered by a page-level editor
 * next to `useUnsavedGuard`. "Keep editing" is the dismiss (Esc included) and stays on the page;
 * "Discard changes" lets the navigation continue to where it was going. A dialog editor does not
 * use this — it asks in place (`DialogGuardBody`) so dialogs never stack (DLG-005).
 */
export function UnsavedChangesDialog({ guard }: { guard: UnsavedGuard }) {
  const { t } = useTranslation();
  if (!guard.blocked) return null;
  return (
    <ConfirmDialog
      title={t('unsaved.title')}
      consequence={t('unsaved.consequence')}
      confirmLabel={t('unsaved.discard')}
      cancelLabel={t('unsaved.keep')}
      destructive
      dismissOnLeave={false}
      onConfirm={guard.proceed}
      onCancel={guard.stay}
    />
  );
}
